export default {
  data () {
    return {
      isShowFilter: true,
      filterState: false
    }
  },
  computed: {
    getTableFilters () {
      return this.filter.fields || {}
    }
  },
  methods: {
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    checkFilters (data) {
      this.filterState = false
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          if (Array.isArray(data[key].value)) {
            if (data[key].value.length) {
              this.filterState = true
              break
            }
          } else if (data[key].value) {
            this.filterState = true
            break
          }
        }
      }
    },
    usersFilter (arr, filterByUserValue) {
      const users = []
      for (const i in filterByUserValue) {
        const userIndex = arr.map(item => item.user.id).indexOf(filterByUserValue[i].id)
        if (userIndex !== -1) {
          users.push(arr[userIndex])
        }
      }

      return users
    },
    statusFilter (arr, filterByUserStatusValue) {
      let users = arr.slice()
      if (filterByUserStatusValue.status === 'active') {
        users = users.filter(item => item.user.exit_at === null)
      } else if (filterByUserStatusValue.status === 'inactive') {
        users = users.filter(item => !!item.user.exit_at)
      }

      return users
    },
    rolesFilter (arr, filterByUserRoleValue) {
      let users = arr.slice()
      if (filterByUserRoleValue.some(role => role.name === 'all')) {
        return users
      }
      users = users.filter((user) => {
        if (user.user.roles) {
          return this.checkRoles(filterByUserRoleValue, user)
        } else {
          return false
        }
      })

      return users
    },
    checkRoles (filter, user) {
      console.log(user, 'user')
      let check = false
      user.user.roles.forEach((role) => {
        filter.some((filterRole) => {
          if (filterRole.id === role.id) {
            check = true
          }
        })
      })

      return check
    },
    emplTypeFilter (arr, emplTypeFilterValue) {
      let users = arr.slice()
      if (emplTypeFilterValue.type !== 'all') {
        users = users.filter(item => item.user.employment_type.type === emplTypeFilterValue.type)
      }

      return users
    },
    partnersFilter (arr, partnersFilterValue) {
      const currentArr = arr.slice()
      let users = []

      if (partnersFilterValue.some(item => item.company_name === 'All partners')) {
        return currentArr.filter(item => item.user.partner_id)
      }

      for (const i in partnersFilterValue) {
        const findByPartner = currentArr.filter(item => item.user.partner_id === partnersFilterValue[i].id)
        users = [...users, ...findByPartner]
      }

      return users
    },
    checkChanges (fields) {
      if (fields.employment_type.value && fields.employment_type.value.type === 'partner') {
        fields.partners.hidden = false
      } else {
        fields.partners.hidden = true
        fields.partners.value.length = 0
      }
      this.$forceUpdate()
    }
  }
}
